import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const m = (v) => (v == null ? "" : Number(v).toFixed(2));
const money = (v) => (v == null ? "" : `$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const HEAD = ["#", "Pay date", "Gross", "Traditional", "Roth", "Agency 1%", "Match", "Expected agency", "Actual you", "Actual agency", "Cumulative", "Verified", "Note"];

function save(blob, name) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export function exportCsv(rows, year) {
  const esc = (s) => `"${String(s ?? "").replace(/"/g, '""')}"`;
  const lines = [HEAD.join(",")].concat(rows.map((r) => [r.n, r.date, m(r.gross), m(r.trad), m(r.roth), m(r.auto), m(r.match), m(r.agency), m(r.actual_employee), m(r.actual_agency), m(r.cumEmp + r.cumAgency), r.verified ? "Yes" : "No", esc(r.note)].join(",")));
  save(new Blob([lines.join("\n")], { type: "text/csv" }), `tsp-paycheck-ledger-${year}.csv`);
}

export function exportPdf(rows, year, { name, profile, totals }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
  doc.setFont("helvetica", "bold").setFontSize(16).text(`TSP Paycheck Ledger ${year}`, 40, 44);
  doc.setFont("helvetica", "normal").setFontSize(9).setTextColor(90);
  doc.text(`${name || ""}  ·  ${profile.retirement_system}  ·  ${profile.pay_frequency} pay  ·  salary ${money(profile.salary)}  ·  generated ${new Date().toLocaleDateString()}`, 40, 60);
  doc.setTextColor(20).setFontSize(10);
  doc.text(`Employee total ${money(totals.employee)}    Agency total ${money(totals.agency)}    Verified ${totals.verified}/${rows.length}    Variance ${money(totals.variance)}`, 40, 78);
  autoTable(doc, {
    startY: 92,
    head: [HEAD.slice(0, 12)],
    body: rows.map((r) => [r.n, r.date, money(r.gross), money(r.trad), money(r.roth), money(r.auto), money(r.match), money(r.agency), money(r.actual_employee), money(r.actual_agency), money(r.cumEmp + r.cumAgency), r.verified ? "Yes" : ""]),
    styles: { fontSize: 8, cellPadding: 4, halign: "right" },
    columnStyles: { 0: { halign: "left" }, 1: { halign: "left" }, 11: { halign: "center" } },
    headStyles: { fillColor: [15, 23, 42], textColor: 255, halign: "right" },
    alternateRowStyles: { fillColor: [241, 245, 249] },
    didParseCell: (d) => {
      const r = rows[d.row.index];
      if (d.section === "body" && r?.verified && r.actual_agency != null && r.actual_agency + 0.01 < r.agency) d.cell.styles.textColor = [190, 18, 60];
    },
    margin: { left: 40, right: 40 },
  });
  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(8).setTextColor(120).text(`PillarWealth.io · Estimates for statement verification, not an official TSP record · Page ${i} of ${pages}`, 40, doc.internal.pageSize.getHeight() - 20);
  }
  save(doc.output("blob"), `tsp-paycheck-ledger-${year}.pdf`);
  return doc;
}

export const matchShortfalls = (rows) => rows.filter((r) => r.verified && r.actual_agency != null && r.actual_agency + 0.01 < r.agency);
